/* eslint-disable react/prop-types */
import React from 'react';
export default function ModalProductInfo(_ref) {
  var {
    image,
    name
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "modal-product-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-header-red relative"
  }, image ? /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: name,
    className: "modal-product-image"
  }) : /*#__PURE__*/React.createElement("div", {
    className: "modal-product-image-placeholder"
  })));
}